module.exports = __webpack_public_path__ + "img/Priest-draenei-m-70.0f6e7350.gif";